import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ErrorMessages } from "src/app/shared/common/errormessages";
import { validationmethod } from "src/app/shared/models/validationmethod";
import { LifecycleService } from "src/app/shared/services/lifecycle.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { TaskWorkflowStepComponent } from "./task-workflow-step/task-workflow-step.component";
import { DecisionWorkflowStepComponent } from "./decision-workflow-step/decision-workflow-step.component";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";
import { MatDialog } from "@angular/material/dialog";
import { PlaceholderWorkflowStepComponent } from "./placeholder-workflow-step/placeholder-workflow-step.component";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";

@Component({
    selector: "app-work-flow-steps",
    templateUrl: "./work-flow-steps.component.html",
    styleUrls: ["./work-flow-steps.component.scss"],
    standalone: false
})
export class WorkFlowStepsComponent implements OnInit {
  @ViewChild(TaskWorkflowStepComponent)
  taskComponent!: TaskWorkflowStepComponent;
  @ViewChild(DecisionWorkflowStepComponent)
  decisionComponent!: DecisionWorkflowStepComponent;
  @Input() data: any;
  @Input() workflowName: string;
  @Output() closeEvent = new EventEmitter<any>();
  @Output() backToWorkFlow = new EventEmitter<void>();
  @Output() goToWorkflowPopupEvent = new EventEmitter<void>();
  @Input() workflowId: number;
  allParticipants: string[] = [];
  allVerdicts: string[] = [];
  taskStepData: any;
  nextstepsData: any[] = [];
  states:any;
  validation_messages;
  backgroundColorScreen: string;
  buttonColor: string;
  validations_form: UntypedFormGroup;
  FormValid: UntypedFormGroup;
  taskSteps: { stepid: string; stepname: string }[] = [];
  workflowDto = {
    stepid: "",
    stepname: "",
    description: "",
    steptype: "",
    nextsteps: "",
    taskmode: "",
    nextstate: "",
  };
  roles = [
    { id: 1, name: "Case Entry" },
    { id: 2, name: "Quality Controller (QC)" },
    { id: 3, name: "Head of Safety" },
  ];
  selectedStepType: any;

  stepTypes:any = [];
  buttonName;
  operators = [
    { label: "=", value: "=" },
    { label: "!=", value: "!=" },
    { label: ">", value: ">" },
    { label: "<", value: "<" },
  ];
  @Input() step: any[] = [];
  steps: any = [];
  editTaskData: any;
  rowData: any;
  Accesstypes: any = [];
  taskModes: string[] = ['Manual', 'Automatic'];
  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private snackbar: MatSnackBar,
    private validation: validationmethod,
    private errorMessages: ErrorMessages,
    private lifecycleservice: LifecycleService,
    private service: ReportingServiceService,
    private dialog: MatDialog,
    private spinner: NgxUiLoaderService,
    private commonService: CommonService
  ) {
    this.validation_messages = this.errorMessages.workflow;
  }
 /**
   * @Author Shyam
   * @Date 26/03/2026
   *  @Description: Workflow Steps Component
   */
  ngOnInit(): void {
    this.formValidation();
    console.log(this.workflowId);
    this.Useroles();
     this.commonService.getlookupVauleByLookUpType("Workflow Step Type").subscribe(result => {
      console.log(result);
      this.stepTypes = result;
      console.log(this.stepTypes)

    });
    this.retrieveWorkflowstepsBasedOnWorkflowId();
    this.retrievelifecycleStatesByWorkflowId(this.workflowId);
    console.log(this.data);
    if (this.data) {
      this.buttonName = "Update";
      console.log(this.data);
      const updatedData = this?.data;
      this.workflowDto.stepid = updatedData.stepid;
      this.workflowDto.stepname = updatedData.stepname;
      this.workflowDto.steptype = updatedData.steptype;
      this.workflowDto.description = updatedData.description;
      this.workflowDto.nextsteps = updatedData.nextstepid;
      this.selectedStepType = updatedData.steptype;
      this.workflowDto.taskmode = updatedData.taskmode;
      if (
        this.data &&
        this.selectedStepType === "START" &&
        this.data.taskStep?.controls
      ) {
        // Clear existing FormArray
        this.startOptions.clear();

        // Populate with existing controls from edit data
        this.data.taskStep.controls.forEach((control) => {
          this.startOptions.push(
            new UntypedFormGroup({
              participantLabel: new FormControl(control.participantLabel),
              participantType: new FormControl(control.participantType),
              rolesAllowed: new FormControl(control.rolesAllowed || []),
              rolesNotAllowed: new FormControl(control.rolesNotAllowed || []),
              userGroup: new FormControl(control.userGroup || ""),
              userReference: new FormControl(control.userReference || ""),
            }),
          );
        });
      }
    } else {
      this.buttonName = "Save";
    }

    this.updateNextStepValues();
    this.backgroundColorScreen =
      this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      stepname: new FormControl("", [
        Validators.required,
        this.validation.noWhitespaceValidator,
        this.validation.specialCharacterValidator,
      ]),
      description: new FormControl("", []),
      steptype: new FormControl("", [Validators.required]),
      // startstates: new FormControl("", [Validators.required]),
      startOptions: new FormArray([]),
      nextsteps: new FormControl("",[Validators.required]),
      taskmode: new FormControl("",),
      nextstate: new FormControl("", ),
    });
    // if (!this.data || this.data.taskStep?.controls?.length === 0) {
    this.addStartControl();
    // }
  }

  onCancel() {
    this.closeEvent.emit();
  }
  onSubmit() {
  if (!this.validations_form.valid) {
      this.validations_form.markAllAsTouched();
      this.validation.validateAllFormFields(this.validations_form);
      this.validation.getvalidationmessage();
      return;
    }
    let taskData = null;

    if (this.selectedStepType === "TASK" && this.taskComponent) {
      taskData = this.taskComponent.getFormData();
    } else if (this.selectedStepType === "DECISION" && this.decisionComponent) {
      taskData = this.decisionComponent.sendData();
    } else if (this.selectedStepType === "START") {
      taskData = { controls: this.startOptions.value };
      console.log(taskData);
    } else if (this.selectedStepType === "END") {
      taskData = { type: "END" };
    }else if (this.selectedStepType === "STATECHANGE") {
      taskData = { type: "STATECHANGE", nextState: this.validations_form.value.nextstate };
    }

    const payload = {
      stepid: this.workflowDto.stepid,
      workflowid: this.workflowId,
      stepname: this.validations_form.value.stepname,
      description: this.validations_form.value.description,
      steptype: this.selectedStepType,
      nextsteps: this.validations_form.value.nextsteps,
      taskStep: taskData,
      taskmode: this.validations_form.value.taskmode
    };

    console.log("Final Payload:", payload);
    this.spinner.start()
    this.lifecycleservice.createWorkflowSteps(payload).subscribe((response) => {
      console.log(response);
      if (response.error == true) {
        this.spinner.stop()
        this.snackbar.open(response.statusMessage, "OK", { duration: 3000 });
      } else {
        this.spinner.stop()
        this.snackbar.open(response.statusMessage, "OK", { duration: 3000 });
        this.closeEvent.emit(response.data);
      }
    });

    // this.closeEvent.emit(true);
  }
  onNextStepChange(event) {
    if (event.value === "PLACEHOLDER") {
      const dialogRef = this.dialog.open(PlaceholderWorkflowStepComponent, {
        width: "33vw",
        maxWidth: "33vw",
        disableClose: true,
        data: { workflowId: this.workflowId },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.data) {
          console.log(result);
          console.log(result?.data?.data);
          // Add the newly created placeholder step to your steps list
          this.steps.push(result?.data?.data);
          this.updateNextStepValues();
          this.validations_form.patchValue({
            nextsteps: result?.data?.data.stepid,
          });
        }
      });
    }
  }

  get startOptions(): FormArray {
    return this.validations_form.get("startOptions") as FormArray;
  }
  createStartControl(): UntypedFormGroup {
    return new UntypedFormGroup({
      participantLabel: new FormControl(""),
      participantType: new FormControl(""),
      rolesAllowed: new FormControl([]),
      rolesNotAllowed: new FormControl([]),
      userGroup: new FormControl(""),
      userReference: new FormControl(""),
    });
  }
  addStartControl() {
    this.startOptions.push(this.createStartControl());
  }

  removeStartControl(index: number) {
    this.startOptions.removeAt(index);
  }
  onStepTypeChange(event: any) {
    console.log(event);
    this.selectedStepType = event.value;
    const nextStepsControl = this.validations_form.get("nextsteps");
    const taskModeControl = this.validations_form.get("taskmode");
    nextStepsControl?.reset();
     if (this.selectedStepType === "TASK") {
    taskModeControl?.setValidators([Validators.required]);
  } else {
    taskModeControl?.clearValidators();
    taskModeControl?.setValue(""); // optional reset
  }
  taskModeControl?.updateValueAndValidity();
    if (this.selectedStepType === "START" && this.isStartStepExists()) {
      if (this.isStartStepExists) {
        this.snackbar.open("Only one START step is allowed", "Ok", {
          duration: 5000,
        });
        this.validations_form.patchValue({ steptype: "" });
        return;
      }
      if (this.startOptions.length === 0) {
        this.addStartControl();
      }
    }
    if (this.selectedStepType === "END") {
      if (this.isEndStepExists()) {
        this.snackbar.open("Only one END step is allowed", "Ok", {
          duration: 5000,
        });
        this.validations_form.patchValue({ steptype: "" });
        return;
      } else {
        nextStepsControl?.setValue("AUTO RULES");
      }
    } else {
      nextStepsControl?.setValue("");
    }
    if (this.selectedStepType === "DECISION") {
    //  Remove validation for DECISION
    nextStepsControl?.clearValidators();
    nextStepsControl?.updateValueAndValidity();
  } else {
    //  Add back validation for other types
    nextStepsControl?.setValidators([Validators.required]);
    nextStepsControl?.updateValueAndValidity();
  }

  if (this.selectedStepType === "END") {
    nextStepsControl?.setValue("AUTO RULES");
  }
    this.updateNextStepValues();
  }

  isStartStepExists(): boolean {
    return (this.steps || []).some(
      (step) =>
        step.steptype === "START" && step.stepid !== this.workflowDto.stepid,
    );
  }

  isEndStepExists() {
    return this.steps.some(
      (step) =>
        step.steptype === "END" && step.stepid !== this.workflowDto.stepid,
    );
  }

  onTaskFormChange(data: any) {
    this.taskStepData = data;
  }

  goToWorkflowPopup() {
    this.goToWorkflowPopupEvent.emit();
  }
  goToWorkflows() {
    console.log("Go to Workflows");
    this.backToWorkFlow.emit();
  }

  ensureStartAndEndSteps() {
    // Create START if missing
    if (!this.isStartStepExists()) {
      this.steps.push({
        stepid: "START_AUTO",
        stepname: "Start",
        steptype: "START",
        nextsteps: null,
      });
    }

    // Create END if missing
    if (!this.isEndStepExists()) {
      this.steps.push({
        stepid: "END_AUTO",
        stepname: "End",
        steptype: "END",
        nextsteps: null,
      });
    }
  }

  updateNextStepValues() {
    this.nextstepsData = (this.steps || []).filter((step) => {
      if (step.steptype === "START") return false;
      if (step.stepid === this.workflowDto.stepid) return false;
      return true;
    });
  }

  retrieveWorkflowstepsBasedOnWorkflowId() {
    this.lifecycleservice
      .retrieveWorkflowSteps(this.workflowId)
      .subscribe((response) => {
        console.log(response);
        if (response.error) {
          this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });
        } else {
          // Assign steps properly
          this.steps = response || [];
          // Ensure START and END steps exist
          // this.ensureStartAndEndSteps();
          // Populate next steps excluding current step and START
          this.updateNextStepValues();
          this.taskSteps = this.steps
            .filter((step) => step.steptype === "TASK")
            .map((step) => ({ stepid: step.stepid, stepname: step.stepname }));
          if (this.data) {
            this.validations_form.patchValue({
              nextsteps: Number(this.data.nextstepid),
            });
          }
          this.getParticipantLabels();
          console.log("Next Steps:", this.nextstepsData);
        }
      });
  }

  Useroles(): void {
    const dnsid = this.localStorageSettings.getSettings("dnsName");
    if (dnsid) {
      //this.service.
      this.service
        .getUserRoles(this.localStorageSettings.getSettings("dnsName"))
        .subscribe(
          (response) => {
            this.Accesstypes = response; // Assign fetched user roles to the types array
            console.log(this.Accesstypes);
          },
          (error) => {
            console.error("Error fetching user roles:", error);
          },
        );
    }
  }

  getParticipantLabels() {
    const startStep = this.steps.find((step) => step.steptype === "START");
    if (startStep?.taskStep?.controls) {
      this.allParticipants = startStep.taskStep.controls
        .map((c) => c.participantLabel)
        .filter((label) => !!label);
    }
    console.log("Participants from START:", this.allParticipants);
    if (this.selectedStepType === "DECISION") {
      console.log("workflow Dto", this.workflowDto);
      console.log(this.steps);
      const linkedTask = this.steps.find(
        (step) =>
          step.steptype === "TASK" &&
          step.nextsteps === this.workflowDto.stepname, // workflowDto.stepid = current DECISION step
      );
      console.log(linkedTask);
      if (linkedTask?.taskStep?.taskConfig?.prompts?.verdicts?.length) {
        this.allVerdicts = linkedTask.taskStep.taskConfig.prompts.verdicts.map(
          (v) => v.label,
        );
      } else {
        this.allVerdicts = []; // fallback to default dropdown options in the decision component
      }
      //   const taskStepType = this.steps.find(step=> step.steptype === 'TASK')
      // if(taskStepType?.taskStep?.taskConfig){
      //   console.log(taskStepType.taskStep.taskConfig.prompts.verdicts)
      //   this.allVerdicts = taskStepType.taskStep.taskConfig.prompts.verdicts.map(c=>c.label)
      // }
      console.log("Verdicts from TASK:", this.allVerdicts);
      if (linkedTask) {
        this.taskSteps = [
          {
            stepid: linkedTask.stepid,
            stepname: linkedTask.stepname,
          },
        ];
      } else {
        this.taskSteps = [];
      }

      console.log("Task for Decision:", this.taskSteps);
    }
  }

  setVerdictsForDecisionStep() {
    if (this.selectedStepType !== "DECISION") return;

    // Find the TASK that links to this DECISION
    const linkedTask = this.steps.find(
      (step) =>
        step.steptype === "TASK" && step.nextsteps === this.workflowDto.stepid, // workflowDto.stepid = current DECISION step
    );

    if (linkedTask?.taskStep?.taskConfig?.prompts?.verdicts?.length) {
      this.allVerdicts = linkedTask.taskStep.taskConfig.prompts.verdicts.map(
        (v) => v.label,
      );
    } else {
      this.allVerdicts = []; // fallback to default dropdown options in the decision component
    }
  }

  onStartStateChange(event) {
    console.log("Changing start state");
    console.log(event.value);
    this.workflowDto.nextstate = event.value; 
  }

  retrievelifecycleStatesByWorkflowId(workflowId: number) {
    this.lifecycleservice.retrieveLifecycleStatesByWorkflowId(workflowId).subscribe((response) => {
      console.log(response);
      if (response.error) {
        this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });
      } else {
        this.states = response;
        console.log("Lifecycle States:", this.states);
        if (this.data?.steptype === "STATECHANGE") {
        const nextState = this.data.taskStep?.nextState;

        this.validations_form.patchValue({
          nextstate: nextState
        });
      }
      }
    });
  }
}
